import React from 'react';
import Home from './Home';
import fetch from '../../core/fetch';
import HomeLayout from '../../components/Layout/HomeLayout';

import { getp } from '../../helpers/getProp';
import { trackPageView } from '../../core/analytics';

export default {
  path: '/',

  async action({ store }) {
    const listingFields = store.getState().listingFields.data;

    trackPageView('/');
    // track('PAGEVIEW', {
    //   path: '/',
    // });

    return {
      title: 'Yoodlize - Rent Anything',
      listingFields,
      chunk: 'home',
      component: (
        <HomeLayout>
          <Home />
        </HomeLayout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/home/index.js